import http from "./httpService";
import { config, sessionUsername } from "../config";
import {
  extractMultiSelectIDs,
  getIdentity,
} from "../components/common/commonFuncs";

////////////////////////////////////////////////////////////////
const prefix = "/api/v2/project/";
const apiEndpoint = config.apiEndpoint;
////////////////////////////////////////////////////////////////

export function getProjects() {
  return http.get(apiEndpoint + prefix + "projects", {
    params: {
      Activity_By: getIdentity(),
    },
  });
}

export function getProjectDetails(projectID) {
  return http.get(apiEndpoint + prefix + "projectSettings", {
    params: {
      Activity_By: getIdentity(),
      Project_ID: projectID,
    },
  });
}

export function saveProject(state, formID = null) {
  return http.post(apiEndpoint + prefix + "projectSettings", {
    pId: state.Project_ID,
    pName: state.Project_Name,
    pDescr: state.Project_Description,
    pForm: formID,
    Activity_By: getIdentity(),
  });
}

export function getProjectForms(pid) {
  return http.get(apiEndpoint + prefix + "projectForms", {
    params: {
      Activity_By: getIdentity(),
      Project_ID: pid,
    },
  });
}

export function getProjectUsers(pid) {
  return http.get(apiEndpoint + prefix + "projectUsers", {
    params: {
      Activity_By: getIdentity(),
      Project_ID: pid,
    },
  });
}

export function getProjectLists(pid) {
  return http.get(apiEndpoint + prefix + "projectLists", {
    params: {
      Activity_By: getIdentity(),
      Project_ID: pid,
    },
  });
}

//old
export function updateProjectDetail(state) {
  let forms = extractMultiSelectIDs(state.forms);
  let users = extractMultiSelectIDs(state.users);

  return http.post(apiEndpoint + prefix + "projectSettings", {
    pId: state._id,
    pName: state.project.name,
    pDescr: state.project.description,
    pForm: state.project.MPOG_Link_Form_ID,
    pForms: forms.join(","),
    pUsers: users.join(","),
    Activity_By: getIdentity(),
  });
}

export function removeProject(pid) {
  return http.post(apiEndpoint + prefix + "removeProject", {
    Project_ID: pid,
    Activity_By: getIdentity(),
  });
}

export function getUserProjects() {
  return http.post(apiEndpoint + prefix + "userProjects", {
    Username: (getIdentity() ===undefined) ? getIdentity() : sessionStorage.getItem(sessionUsername),
    Activity_By: getIdentity()
  });
}

export function updateProjectForm(rID, active, pID = null, fName = null) {
  return http.post(apiEndpoint + prefix + "updateProjectForm", {
    Record_ID: rID,
    Project_ID: pID,
    Form_Name: fName,
    Active: active,
    Activity_By: getIdentity(),
  });
}

export function removeProjectForm(rID) {
  return http.post(apiEndpoint + prefix + "removeProjectForm", {
    Record_ID: rID,
    Activity_By: getIdentity(),
  });
}

export function removeProjectList(rID) {
  return http.post(apiEndpoint + prefix + "removeProjectList", {
    Record_ID: rID,
    Activity_By: getIdentity(),
  });
}

export function updateProjectList(pID, lid, lName) {
  return http.post(apiEndpoint + prefix + "addProjectList", {
    Project_ID: pID,
    List_ID: lid,
    List_Name: lName,
    Activity_By: getIdentity(),
  });
}

export function updateProjectUser(record, role, uID = null, pID = null) {
  return http.post(apiEndpoint + prefix + "saveProjectUser", {
    Record_ID: record,
    Role_ID: role,
    Project_ID: pID,
    User_ID: uID,
    Activity_By: getIdentity(),
  });
}

export function removeProjectUser(rID) {
  return http.post(apiEndpoint + prefix + "removeProjectUser", {
    Record_ID: rID,
    Activity_By: getIdentity(),
  });
}
